import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PaywallTaxSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PaywallTaxSettingsPage" */ "@circle-react/components/SettingsApp/PaywallTaxSettings"
    ),
);

export const PaywallTaxSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <PaywallTaxSettingsComponent />
  </Suspense>
);
